import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';

export type LabelProps = {
  className?: string;
  isRequired?: boolean;
  requiredSignClassName?: string;
} & ComponentPropsWithoutRef<'label'>;

export const Label: FC<LabelProps> = ({ children, className, isRequired = false, requiredSignClassName, ...props }) => {
  return (
    <label className={twMerge('block text-sm font-medium text-gray-700 py-2', className)} {...props}>
      {children}
      {isRequired && <sup className={twMerge('text-sm text-gray-700 font-medium', requiredSignClassName)}>*</sup>}
    </label>
  );
};
